module.exports = __webpack_public_path__ + "media/images/tour/d/vi-317f86616e7048b96638bf0229b28bfb.png";